import { useEffect, useState } from 'react'
import { useClientFilter } from './useClientFilter'

/**
 * Estado local de cliente alineado con el filtro global del header.
 * Con filtro global activo: fuerza el id y el select debe quedar disabled.
 */
export function useSyncedLocalClientId(initialValue = '') {
  const { selectedClientId, isFiltering } = useClientFilter()
  const [clientId, setClientIdState] = useState(() =>
    selectedClientId != null ? String(selectedClientId) : initialValue
  )

  useEffect(() => {
    // Al elegir "Todos" hay que limpiar el filtro local; si no, el listado sigue filtrado.
    setClientIdState(selectedClientId != null ? String(selectedClientId) : '')
  }, [selectedClientId])

  const setClientId = (value) => {
    if (isFiltering) return
    setClientIdState(value == null ? '' : String(value))
  }

  return {
    clientId,
    setClientId,
    isGlobalFilterActive: isFiltering,
    selectDisabled: isFiltering,
  }
}

export default useSyncedLocalClientId
